module.exports = __webpack_public_path__ + "img/excellence-reporting.bc7da436.jpg";